import "./UserOptionLabel.css";

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const UserOptionLabel = ({ name, email }) => (
  <div className="uol-opt">
    <span className="uol-avatar">{getInitials(name)}</span>
    <div className="uol-opt-text">
      <span className="uol-opt-name">{name}</span>
      {email && <span className="uol-opt-email">{email}</span>}
    </div>
  </div>
);

export default UserOptionLabel;
